import React, { useState, useCallback } from 'react';
import { Table, Typography } from 'antd';

const { Column } = Table;
const { Text } = Typography;
const defaultPageSize = 40;
const defaultCurrentPage = 1;

const CommonTable: React.FC<{
  items: any[];
  rowKey?: string;
  scrollHeight?: number;
  className?: string;
  disablePagination?: boolean;
  fixedHeightInsideModal?: boolean; // when true, ensure's height of table does not exceed height of page when inside a modal
}> = ({
  items,
  rowKey,
  children,
  scrollHeight,
  className,
  disablePagination = false,
  fixedHeightInsideModal = false,
}) => {
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [currentPage, setCurrentPage] = useState(defaultCurrentPage);
  const onPaginationChange = useCallback((page: number, pageSize?: number) => {
    setCurrentPage(page);
    if (pageSize) setPageSize(pageSize);
  }, []);

  const onSizeChange = useCallback(
    () => setCurrentPage(defaultCurrentPage),
    [],
  );

  const getNumber = useCallback(
    (index) => `#${(currentPage - 1) * pageSize + index + 1}`,
    [currentPage, pageSize],
  );

  const gefaultPaginationConfig: any = {
    defaultPageSize: defaultPageSize,
    current: currentPage,
    showSizeChanger: true,
    position: 'both',
    size: 'small',
    onChange: onPaginationChange,
    onShowSizeChange: onSizeChange,
  };

  if (fixedHeightInsideModal) {
    className = `${className ? className : ''} modal-table-fixed-height`;
  }

  return (
    <Table
      size="small"
      bordered
      dataSource={items}
      rowKey={rowKey || 'guid'}
      className={className}
      pagination={
        items.length <= 10 || disablePagination
          ? false
          : gefaultPaginationConfig
      }
      scroll={{
        y: scrollHeight || 900,
      }}
    >
      <Column
        align="center"
        width="4rem"
        key="getNumber"
        title=""
        render={(text, _, index: number) => (
          <Text key={index}>{getNumber(index)}</Text>
        )}
      />
      {children}
    </Table>
  );
};

export default CommonTable;
